// extracted by mini-css-extract-plugin
export default {"FrameContainer":"Frame_FrameContainer__6Sbp3","Frame":"Frame_Frame__qPB2s","FullScreen":"Frame_FullScreen__fyh5R"};